import "./style.scss";
import { FC, MouseEventHandler, ReactNode } from "react";

interface IBtnDefault {
  reverse?: boolean;
  disabled?: boolean;
  onlyIcon?: boolean;
  // style?: CSSProperties;
  children: ReactNode;
  onClick?: MouseEventHandler<HTMLDivElement>;
  // customClass?: string;
}

const BtnDefault: FC<IBtnDefault> = ({ reverse, disabled, children, onClick, onlyIcon }) => {
  const handleClick: MouseEventHandler<HTMLDivElement> = (event) => {
    if (disabled) return;
    onClick?.(event);
  };

  return (
    <div
      className={`btn-default ${reverse ? "reverse" : ""} ${disabled ? "disabled" : ""} ${onlyIcon ? "only-icon" : ""}`}
      // style={style}
      onClick={handleClick}
    >
      {children}
    </div>
  );
};

export default BtnDefault;
